var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fab1bfff",
    height: "256px",
    width: "256px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 284 284",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224,65.667h60v-9C284,32.589,264.411,13,240.334,13H43.667C19.589,13,0,32.589,0,56.667v9h60c5.522,0,10,4.477,10,10 s-4.478,10-10,10H0V129c0,2.689,0.083,5.359,0.23,8.011c7.074-1.948,14.383-2.948,21.853-2.948 c45.379,0,82.298,36.918,82.298,82.297c0,16.062-4.754,31.782-13.492,45.119C106.757,267.622,123.99,271,142,271 c18.009,0,35.241-3.378,51.108-9.52c-8.738-13.337-13.491-29.053-13.491-45.12c0-45.379,36.918-82.297,82.297-82.297 c7.47,0,14.781,1.001,21.855,2.949c0.148-2.653,0.23-5.323,0.23-8.012V85.667H224c-5.522,0-10-4.477-10-10 S218.478,65.667,224,65.667z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.083,154.063c-6.63,0-13.092,1.027-19.284,3.045c8.281,41.073,34.342,75.779,69.776,95.724 c7.63-10.564,11.806-23.366,11.806-36.472C84.381,182.009,56.435,154.063,22.083,154.063z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M261.914,154.063c-34.351,0-62.297,27.946-62.297,62.297c0,13.109,4.176,25.908,11.806,36.472 c35.435-19.944,61.497-54.65,69.777-95.723C275.007,155.091,268.545,154.063,261.914,154.063z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaper);
export default __webpack_public_path__ + "static/media/diaper.4124f79ace71b9ca9b4fd809ac40f287.svg";
export { ForwardRef as ReactComponent };